import axios from 'axios'
var root = process.env.API_ROOT;
window.__orderData = '';
//微信SDK
window.WXJS_CFG = localStorage.getItem("WXSDK") || {
						debug: false,
						appId: 'wx25f9e2ff9778d42f',
						timestamp: 0,
						nonceStr: 'HXQD7LXDtf',
						signature: 'd6621caeb629f147e03919d12d36ec10f343a0a2',
						jsApiList: ['checkJsAPi','scanQRCode','chooseWXPay','onMenuShareTimeline']
					};
//系统参数 ex2898901
window.__CFG = window.__CFG || {
    'APIURL': root,
    'URL': 'http://sms.enjoyme.cn',
    'WX_IMG': localStorage.getItem("WXIMG") || '',
    'CARD_N': localStorage.getItem("CARD") || '',
    'WX_OPENID': localStorage.getItem("WXOPENID") || '',
	'WX_UNIONID': localStorage.getItem("WXUNIONID") || '',
    'WX_CODE':'',
	// "ParentId":localStorage.getItem("ID") || '',
	"ParentId":sessionStorage.getItem("ID") || '',
	"UserId":localStorage.getItem("USERID") || '',
	"Authorization":localStorage.getItem("Authorization") || '',
	"lableType":localStorage.getItem("LableType") || '',
    "DOCUMENT_TITLE":document.title,
    "IN_WEIXIN":true
};

function callapi2(parmas, callback) {
	parmas = parmas || {};
	callback = typeof(callback) == 'function' ? callback : function(res) {};
	//公共参数
	var config2 = {
		headers: {
			'client':'worker',
			'Authorization':''
		},
		method: "post",
		baseURL: '/'
	};
	axios.post(window.__CFG.APIURL+"/api/login/getOpenid",parmas, config2)
		.then((res) => {
			if(res.status == 200){ //获取openid值成功
				callback(res.data);
			} else{
				// console.log(res);
			}
		})
		.catch(function(err) {
			console.log("err",err);
		})
};

//请求方法
function callapi(api, parmas, callback) {
    parmas = parmas || {};
    callback = typeof(callback) == 'function' ? callback : function(res) {};
	parmas['openid'] =  window.__CFG.WX_OPENID;
	console.log(parmas['openid']);
    //公共参数
    var config = {
        headers: {
			'client':'worker',
			'Authorization':window.__CFG.Authorization
        },
        method: "post",
        baseURL: '/'
    };

    axios.post(window.__CFG.APIURL+api, parmas, config)
        .then((res) => {
				console.log(res);
			if(res.status == 200){ //请求成功
				// var code = ''
				// if(res.data.code == 1001){
				// 	code = res.data.code;
				// }
				// if(code == 1001){
				// 	if(localStorage.getItem("Authorization")){
				// 		localStorage.removeItem("Authorization");
				// 		localStorage.removeItem("LableType");
				// 	}
				// 	Login((re) => {
				// 		window.__CFG.Authorization = re.data.Authorization;
				// 		window.__CFG.lableType = re.data.lableType;
				// 		localStorage.setItem("Authorization",re.data.Authorization);
				// 		localStorage.setItem("LableType",re.data.lableType);
				// 		return false;
				// 	});
				// }
				callback(res.data);
			} else{
				// console.log(res);
			}
        })
        .catch(function(err) {
            console.log("err",err);
        })
};

// 登录
function Login (callback) {
	callback = typeof(callback) == 'function' ? callback : function(res) {};
	callapi('/api/login/login', {}, (res) => {
		if(res.status == 1){
			window.__CFG.Authorization = res.data.Authorization;
			window.__CFG.lableType = res.data.lableType;
			localStorage.setItem("Authorization",res.data.Authorization);
			localStorage.setItem("LableType",res.data.lableType);
			callback();
		}else{
			// alert('请求失败');
		}
	});
};

//判断是否微信
function checkIsWeixin() {
    if (/(micromessenger)/.test(navigator.userAgent.toLowerCase())) {
        return true;
    } else {
        return false;
    }
};

export default {
    //网页分享
    webshare(title,desc,link,imgUrl){
        if(checkIsWeixin()){
            wx.ready(function(){
                wx.onMenuShareTimeline({
                    title: title, // 分享标题
                    desc: desc, // 分享描述
                    link: link, // 分享链接
                    imgUrl: imgUrl, // 分享图标
                    success: function () {
                        console.log("执行1");
                    },
                    cancel: function () {
						console.log("执行2");
                        // 用户取消分享后执行的回调函数
                    }
                });
                wx.onMenuShareAppMessage({
                    title: title, // 分享标题
                    desc: desc, // 分享描述
                    link: link, // 分享链接
                    imgUrl: imgUrl, // 分享图标
                    type: '', // 分享类型,music、video或link，不填默认为link
            
                    dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                    success: function () {
                        console.log("执行3");
                    },
                    cancel: function () {
						console.log("执行4");
                    }
                });
                wx.onMenuShareQQ({
                    title: title, // 分享标题
                    desc: desc, // 分享描述
                    link: link, // 分享链接
                    imgUrl: imgUrl, // 分享图标
                    success: function () {
                       console.log("执行5");
                    },
                    cancel: function () {
						console.log("执行6");
                       // 用户取消分享后执行的回调函数
                    }
                });
            });
        };
    },
	
	//路径字段查找
	getUrlParms(name){
		return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
	},

    //提示框
    tipload(glo, msg, isback) {
        glo.tipshow = true
        glo.tips = msg
        setTimeout(function() {
            glo.tipshow = false;
            if (isback) {
                glo.$router.go(-1)
            }
        }, 2000)
    },
	callapi2:callapi2,

    //接口
    sendcode(params, callback) {
        return callapi('/api/sms/send', params, callback) //发送短信
    },
	isbinding(params, callback) {
	    return callapi('/api/login/isRegister', params, callback) //是否绑定
	},
	binding(params, callback) {
	    return callapi('/api/login/register', params, callback) //绑定手机号
	},
	login(params, callback) {
	    return callapi('/api/login/login', params, callback) //登录
	},
	consumerecord(params, callback) {
	    callapi('/api/order/orderList', params, callback) //消费记录
	},
	getCardInfo(params, callback) {
		return callapi('/api/card/getCardInfo', params, callback) //获取信息
	},
	selldata(params, callback) {
	    return callapi('/api/card/sellCardAchievement', params, callback) //销售排名及金额数据
	},
	sellrecord(params, callback) {
	    return callapi('/api/card/sellCardList', params, callback) //销售详细数据记录
	},
	rechargestyle(params, callback) {
	    return callapi('/api/invest/investType', params, callback) //充值分类展示
	},
	getqrcode(params, callback) {
	    return callapi('/api/card/getQRCode', params, callback) //推广二维码生成接口
	},
	getsdk(params, callback) {
	    return callapi('/api/pay/getJSSDK', params, callback) //支付SDK
	},
	submitpay(params, callback) {
	    return callapi('/api/pay/investCard', params, callback) //支付请求
	},
	getpaycode(params, callback) {
	    return callapi('/api/card/getConsumptionCode', params, callback) //展示支付二维码
	},
	getcoupon(params, callback) {
	    return callapi('/api/coupon/getCouponList', params, callback) //客户优惠券列表
	},
	getcouponcode(params, callback) {
	    return callapi('/api/coupon/getCouponCode', params, callback) //客户优惠券使用出示二维码
	},
	getconsumecard(params, callback) {
	    return callapi('/api/consume_card/getConsumeCard', params, callback) //获取要绑卡卡信息
	},
	bindconsumecard(params, callback) {
	    return callapi('/api/consume_card/bindConsumeCard', params, callback) //绑卡
	},
	cancelrefund(params, callback) {
	    return callapi('/api/refund_card/cancel', params, callback) //取消退款
	},
	refundsubmit(params, callback) {
	    return callapi('/api/refund_card/bindBankCard', params, callback) //退款
	},
	getrefund(params, callback) {
	    return callapi('/api/refund_card/getRefundCard', params, callback) //获取退款信息
	}
}



// WEBPACK FOOTER //
// ./src/api/api.js